
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';

    @Component({})
    export default class CustomFancyThingsQuestion extends Vue {
        @Prop() public question: Question;
        public optionId?: number = 0;
        public propertyValue = 0;
        public rooms = {
            electronic: {
                number: 0,
                value: 0,
                singleValue: 300000,
                expanded: false,
                title: 'Electronique',
                icon: 'laptop.svg'

            },
            jewelry: {
                number: 0,
                value: 0,
                singleValue: 300000,
                expanded: false,
                title: 'Bijoux',
                icon: 'wedding-rings.svg'
            },
            other: {
                number: 0,
                value: 0,
                singleValue: 700000,
                expanded: false,
                title: 'Autres trésors',
                icon: 'banknote.svg'
            },

        };

        mounted() {
            const answer = this.question.currentResponse!;
            const types = ['electronic', 'jewelry', 'other'];
            console.log(answer);
            for (let type in types) {
                if(answer.customData.hasOwnProperty(types[type])){
                    this.rooms[types[type]] = answer.customData[types[type]];
                }
            }

        }

        public recalculatePropertyValue(typeOfRoom: string) {
            this.updatePropertyValue();
        }


        public increase(typeOfRoom){
            this.rooms[typeOfRoom].number++;
            this.rooms[typeOfRoom].value = this.rooms[typeOfRoom].number * this.rooms[typeOfRoom].singleValue;
            this.recalculatePropertyValue(typeOfRoom);
        }

        hideDetails(typeOfRoom) {
            this.rooms[typeOfRoom].expanded = false;
        }
        showDetails(typeOfRoom) {
            if(this.rooms[typeOfRoom].expanded === true){
                return;
            }
            for(let roomType in this.rooms){
                this.rooms[roomType].expanded = false;
            }
            this.rooms[typeOfRoom].expanded = true;
        }
        public decrease(typeOfRoom){

            if(this.rooms[typeOfRoom].number === 0){
                return;
            }
            this.rooms[typeOfRoom].number--;
            this.rooms[typeOfRoom].value = this.rooms[typeOfRoom].number * this.rooms[typeOfRoom].singleValue;
            this.recalculatePropertyValue(typeOfRoom);
        }

        respond() {
            this.question.currentResponse!.value = this.propertyValue + '';
            this.question.currentResponse!.customData = this.rooms;
            this.question.validate();
            this.question.changedEvent.emit('changed');
        }

        updatePropertyValue() {
            this.propertyValue = parseInt(this.rooms.electronic.value + '')  + parseInt(this.rooms.jewelry.value + '')  + parseInt(this.rooms.other.value + '')  ;
        }


    }
